import { SEO, breadcrumbSchema } from "../components/SEO";
import { Breadcrumbs } from "../components/Breadcrumbs";
import { ProblemCard } from "../components/Cards";
import { CTASection } from "../components/CTASection";
import { Reveal } from "../components/Reveal";
import { PagePhoto } from "../components/PagePhoto";
import { pagePhotos } from "../content/photos";
import { useLp } from "../i18n/lang";
import { useCopy } from "../i18n/copy";
import { useProblems } from "../i18n/content";

export default function ProblemsHub() {
  const c = useCopy("problemsHub");
  const cr = useCopy("crumbs");
  const lp = useLp();
  const problems = useProblems();
  const crumbs = [
    { name: cr.home, path: lp("/") },
    { name: cr.problems, path: lp("/problemas/") },
  ];
  return (
    <>
      <SEO
        title={c.seoT}
        description={c.seoD}
        path="/problemas/"
        jsonLd={[breadcrumbSchema(crumbs)]}
      />
      <Breadcrumbs items={crumbs} />
      <section className="container-site section-gap !pt-10" data-testid="problems-hub">
        <Reveal>
          <p className="tech-label mb-4">{c.kicker}</p>
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-3xl">
            {c.h1}
          </h1>
          <p className="mt-5 max-w-2xl text-base sm:text-lg text-slate-600 leading-relaxed">
            {c.intro}
          </p>
        </Reveal>
        <PagePhoto photo={pagePhotos["_hub-problemas"]} className="mt-12 max-w-4xl" />
        <div className="mt-12 grid sm:grid-cols-2 gap-4 max-w-5xl">
          {problems.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.04}><ProblemCard problem={p} /></Reveal>
          ))}
        </div>
      </section>
      <CTASection title={c.ctaT} text={c.ctaX} />
    </>
  );
}
